export default "__VITE_ASSET__BrLUs$os__"